/* ============================================================
   LUMIÈRE 主题脚本(原生 JS,无任何外部依赖)
   1) 左侧抽屉菜单:打开/关闭 + 二级菜单展开
   2) 商品图片画廊:缩略图点击 / 左右箭头 / 键盘方向键 切换
   3) 桌面端 Mega Menu + Bestsellers 商品轮播
   ============================================================ */
(function () {
  "use strict";

  /* 用户的「减少动态效果」系统设置 —— 全局共用:
     滚动渐现、Hero 轮播、Featured 轮播、商品轮播都据此关闭自动动画。 */
  var REDUCE_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 左侧抽屉菜单 ---------- */
  var burger = document.querySelector("[data-drawer-toggle]");

  function setDrawer(open) {
    document.body.classList.toggle("drawer-open", open);
    var drawer = document.getElementById("MenuDrawer");
    if (burger) burger.setAttribute("aria-expanded", open ? "true" : "false");
    if (drawer) drawer.setAttribute("aria-hidden", open ? "false" : "true");
  }

  document.addEventListener("click", function (event) {
    // 点汉堡:切换开/关
    if (event.target.closest("[data-drawer-toggle]")) {
      event.preventDefault();
      setDrawer(!document.body.classList.contains("drawer-open"));
      return;
    }
    // 点关闭按钮或遮罩:关闭
    if (event.target.closest("[data-drawer-close]")) {
      setDrawer(false);
      return;
    }
    // 点有子菜单的一级项:展开/收起二级菜单
    var toggle = event.target.closest("[data-submenu-toggle]");
    if (toggle) {
      var parent = toggle.closest(".drawer-item--parent");
      if (parent) {
        var isOpen = parent.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }
    }
  });

  // 按 Esc 关闭抽屉
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && document.body.classList.contains("drawer-open")) {
      setDrawer(false);
    }
  });

  /* ---------- 桌面端全宽 Mega Menu ----------
     悬停展开由 CSS(:hover / :focus-within)负责;
     这里补齐:点击箭头切换、Escape 关闭、点击面板外关闭、aria-expanded 同步 */
  var megaItems = Array.prototype.slice.call(
    document.querySelectorAll("[data-mega-item]")
  );

  function setMega(item, open) {
    item.classList.toggle("is-open", open);
    var toggle = item.querySelector("[data-mega-toggle]");
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    // 可见性完全由 .is-open 类决定,不再需要 blur() —— 避免破坏键盘焦点
  }

  function closeAllMega(except) {
    megaItems.forEach(function (item) {
      if (item !== except) setMega(item, false);
    });
  }

  var OPEN_DELAY = 100;   // hover intent:进入 Catalog 后略等再开,避免路过误触
  var CLOSE_DELAY = 150;  // 离开后略等再关,允许鼠标从 Catalog 平滑移入面板

  function clearMegaTimers(item) {
    if (item._megaOpenTimer) { window.clearTimeout(item._megaOpenTimer); item._megaOpenTimer = null; }
    if (item._megaCloseTimer) { window.clearTimeout(item._megaCloseTimer); item._megaCloseTimer = null; }
  }
  function cancelAllMegaOpens() {
    megaItems.forEach(function (item) {
      if (item._megaOpenTimer) { window.clearTimeout(item._megaOpenTimer); item._megaOpenTimer = null; }
    });
  }
  function scheduleOpen(item) {
    if (item._megaCloseTimer) { window.clearTimeout(item._megaCloseTimer); item._megaCloseTimer = null; }
    if (item.classList.contains("is-open") || item._megaOpenTimer) return;
    item._megaOpenTimer = window.setTimeout(function () {
      item._megaOpenTimer = null;
      closeAllMega(item);
      setMega(item, true);
    }, OPEN_DELAY);
  }
  function scheduleClose(item) {
    if (item._megaOpenTimer) { window.clearTimeout(item._megaOpenTimer); item._megaOpenTimer = null; }
    if (item._megaCloseTimer) return;
    item._megaCloseTimer = window.setTimeout(function () {
      item._megaCloseTimer = null;
      setMega(item, false);
    }, CLOSE_DELAY);
  }

  if (megaItems.length > 0) {
    megaItems.forEach(function (item) {
      var navLink = item.querySelector(".nav-link");
      var toggle = item.querySelector("[data-mega-toggle]");
      var panel = item.querySelector("[data-mega-panel]");

      // 触发区 = 顶部 Catalog 文字 + 展开箭头(不含全宽面板)。
      // 悬停意图只从这两个真实区域产生,隐藏面板区域永远不会触发打开。
      [navLink, toggle].forEach(function (el) {
        if (!el) return;
        el.addEventListener("mouseenter", function () { scheduleOpen(item); });
        el.addEventListener("mouseleave", function () { scheduleClose(item); });
      });

      // 已打开的面板:鼠标移入保持打开;移出则关闭
      if (panel) {
        panel.addEventListener("mouseenter", function () { clearMegaTimers(item); });
        panel.addEventListener("mouseleave", function () { scheduleClose(item); });
      }

      // 键盘:焦点进入 Catalog(按钮或面板内)即打开;焦点完全离开则关闭
      item.addEventListener("focusin", function () {
        clearMegaTimers(item);
        closeAllMega(item);
        setMega(item, true);
      });
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) {
          clearMegaTimers(item);
          setMega(item, false);
        }
      });
    });

    document.addEventListener("click", function (event) {
      // 点箭头按钮:切换展开状态(同时收起其他面板)
      var toggle = event.target.closest("[data-mega-toggle]");
      if (toggle) {
        var item = toggle.closest("[data-mega-item]");
        clearMegaTimers(item);
        var willOpen = !item.classList.contains("is-open");
        closeAllMega(item);
        setMega(item, willOpen);
        return;
      }
      // 点击触发项与面板以外的区域:全部关闭
      if (!event.target.closest("[data-mega-item]")) {
        cancelAllMegaOpens();
        closeAllMega();
      }
    });

    // Escape 关闭所有 Mega Menu,并把焦点还给当前展开项的触发按钮
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      var openItem = megaItems.filter(function (item) {
        return item.classList.contains("is-open");
      })[0];
      megaItems.forEach(clearMegaTimers);
      closeAllMega();
      if (openItem) {
        var t = openItem.querySelector("[data-mega-toggle]");
        if (t) t.focus();
      }
    });

    // 购物车优先级:鼠标移入右侧功能区(Globe/搜索/购物车)时,
    // 取消所有待执行的打开计时器并立即关闭 Catalog —— 隐藏面板绝不拦截 Checkout。
    var headerRight = document.querySelector(".site-header__right");
    if (headerRight) {
      headerRight.addEventListener("mouseenter", function () {
        cancelAllMegaOpens();
        closeAllMega();
      });
      // 指针一按下(点购物车/搜索/Globe)也立即取消挂起的打开
      headerRight.addEventListener("pointerdown", function () {
        cancelAllMegaOpens();
        closeAllMega();
      });
    }
  }

  /* ---------- Catalog 右侧 Featured Collection 轮播 ----------
     ===== 实验性功能,可单独回退 =====
     · 多张 Slide 叠放,定时淡入淡出自动切换
     · 悬停/聚焦左侧 Collection 卡片时,右图联动切到同一 Collection
     · 悬停右图本身、面板失焦、标签页隐藏时暂停;交互结束后恢复
     · prefers-reduced-motion:不自动切换,仅保留卡片联动
     回退方式:删除本段 + init()/section 生命周期里的 initAllFeaturedCarousels 调用。 */
  function initFeaturedCarousel(root) {
    if (!root || root.dataset.featuredCarouselInit === "1") return;
    root.dataset.featuredCarouselInit = "1";

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-featured-slide]"));
    if (slides.length === 0) return;

    var panel = root.closest("[data-mega-panel]");
    var cards = panel
      ? Array.prototype.slice.call(panel.querySelectorAll("[data-featured-target]"))
      : [];

    var interval = parseInt(root.getAttribute("data-featured-interval"), 10);
    if (isNaN(interval)) interval = 4000;
    interval = Math.min(8000, Math.max(3000, interval));

    var idx = Math.max(0, slides.findIndex(function (s) {
      return s.classList.contains("is-active");
    }));
    var timer = null;
    var paused = false;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var active = n === idx;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
        if (active) slide.removeAttribute("tabindex");
        else slide.setAttribute("tabindex", "-1");
      });
    }

    function stop() {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }
    function schedule() {
      stop();
      if (paused || REDUCE_MOTION || slides.length < 2 || document.hidden) return;
      timer = window.setTimeout(function () {
        show(idx + 1);
        schedule();
      }, interval);
    }

    /* 左侧卡片 → 右图联动 */
    cards.forEach(function (card) {
      var handle = card.getAttribute("data-featured-target");
      var target = slides.findIndex(function (s) {
        return s.getAttribute("data-featured-index") === handle;
      });
      if (target < 0) return;
      function focusSlide() {
        paused = true;
        stop();
        show(target);
      }
      function release() {
        paused = false;
        schedule();
      }
      card.addEventListener("mouseenter", focusSlide);
      card.addEventListener("mouseleave", release);
      card.addEventListener("focus", focusSlide);
      card.addEventListener("blur", release);
    });

    /* 悬停右图本身时暂停 */
    root.addEventListener("mouseenter", function () { paused = true; stop(); });
    root.addEventListener("mouseleave", function () { paused = false; schedule(); });

    /* 后台标签页暂停 */
    function onVisibility() {
      if (document.hidden) stop();
      else schedule();
    }
    document.addEventListener("visibilitychange", onVisibility);

    /* 面板关闭时停表,展开时重新开始 —— 观察 mega item 的 is-open 类 */
    var megaItem = root.closest("[data-mega-item]");
    var observer = null;
    if (megaItem && "MutationObserver" in window) {
      observer = new MutationObserver(function () {
        if (megaItem.classList.contains("is-open")) schedule();
        else stop();
      });
      observer.observe(megaItem, { attributes: true, attributeFilter: ["class"] });
    }

    root._featuredCarouselCleanup = function () {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
      if (observer) observer.disconnect();
      delete root.dataset.featuredCarouselInit;
    };

    show(idx);
    schedule();
  }

  function initAllFeaturedCarousels() {
    var nodes = document.querySelectorAll("[data-featured-carousel]");
    Array.prototype.forEach.call(nodes, initFeaturedCarousel);
  }

  /* ---------- 商品图片画廊 ---------- */
  function initGallery(gallery) {
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-gallery-slide]")
    );
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-gallery-thumb]")
    );
    if (slides.length === 0) return;

    var prevBtn = gallery.querySelector("[data-gallery-prev]");
    var nextBtn = gallery.querySelector("[data-gallery-next]");
    var counter = gallery.querySelector("[data-gallery-counter]");
    var total = slides.length;
    var current = 0;

    function goTo(index) {
      // 循环:超出范围就绕回另一端
      current = (index + total) % total;

      slides.forEach(function (img, i) {
        img.classList.toggle("is-active", i === current);
      });
      thumbs.forEach(function (btn, i) {
        var active = i === current;
        btn.classList.toggle("is-active", active);
        // 仅当缩略图行自身可滚动时才对齐（行不溢出时 scrollIntoView 会滚动整页——
        // 变体同步脚本程序化点击缩略图的场景不能引发页面跳动）
        var row = btn.parentElement;
        if (active && btn.scrollIntoView && row &&
            (row.scrollWidth > row.clientWidth || row.scrollHeight > row.clientHeight)) {
          btn.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      });
      if (counter) {
        counter.textContent = current + 1 + " / " + total;
      }
    }

    // 缩略图点击
    thumbs.forEach(function (btn, i) {
      btn.addEventListener("click", function () {
        goTo(i);
      });
    });

    // 左右箭头
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goTo(current + 1);
      });
    }

    // 键盘左右方向键(聚焦主图区域时生效)
    var stage = gallery.querySelector("[data-gallery-stage]") || gallery;
    stage.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goTo(current - 1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        goTo(current + 1);
      }
    });

    // 初始化到第一张
    goTo(0);
  }

  function initAllGalleries() {
    var galleries = document.querySelectorAll("[data-gallery]");
    Array.prototype.forEach.call(galleries, initGallery);
  }

  /* ---------- 国家 / 货币选择器 ----------
     只负责:开关面板、aria-expanded、点击外部关闭、Escape 关闭、焦点归还。
     国家切换本身由 Liquid 里的 {% form 'localization' %} 原生 submit 完成 ——
     此处不做任何汇率计算、价格字符串或货币符号处理。 */
  function initCountrySelector(root) {
    if (!root || root.dataset.countrySelectorInit === "1") return;   // 防重复初始化
    root.dataset.countrySelectorInit = "1";

    var trigger = root.querySelector("[data-country-selector-trigger]");
    var panel = root.querySelector("[data-country-selector-panel]");
    if (!trigger || !panel) return;

    function isOpen() {
      return root.classList.contains("is-open");
    }

    function open() {
      panel.hidden = false;
      // 同步强制一次重排,让随后的类切换能产生过渡。
      // 不用 rAF —— 后台标签页里 rAF 被节流,状态类会迟迟不落,
      // 导致 isOpen() 判断失真、二次点击与 Escape 失效。
      void panel.offsetHeight;
      root.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    }

    function close(returnFocus) {
      if (!isOpen() && panel.hidden) return;
      root.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      // 过渡结束后再隐藏,保证关闭动画可见;隐藏后面板内不可点击也不可聚焦
      window.setTimeout(function () {
        if (!root.classList.contains("is-open")) panel.hidden = true;
      }, 200);
      if (returnFocus) trigger.focus();
    }

    trigger.addEventListener("click", function () {
      if (isOpen()) close(false);
      else open();
    });

    // 点击面板与触发按钮以外的区域:关闭
    function onDocClick(e) {
      if (!root.contains(e.target)) close(false);
    }
    document.addEventListener("click", onDocClick);

    // Escape:关闭并把焦点还给触发按钮
    function onKeydown(e) {
      if (e.key === "Escape" && isOpen()) {
        e.stopPropagation();
        close(true);
      }
    }
    document.addEventListener("keydown", onKeydown);

    // Tab 移出面板后自动关闭(键盘用户不会被困住)
    root.addEventListener("focusout", function (e) {
      if (isOpen() && !root.contains(e.relatedTarget)) close(false);
    });

    // Theme Editor section 卸载时清理文档级监听
    root._countrySelectorCleanup = function () {
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKeydown);
      delete root.dataset.countrySelectorInit;
    };
  }

  function initAllCountrySelectors() {
    var nodes = document.querySelectorAll("[data-country-selector]");
    Array.prototype.forEach.call(nodes, initCountrySelector);
  }

  /* ---------- 首页 Hero 双图轮播 ----------
     淡入淡出(CSS transition),单一定时器;悬停/聚焦/后台暂停;
     圆点切换 + 触摸横滑;非当前 Slide aria-hidden 且按钮不可聚焦;
     prefers-reduced-motion 时禁用自动播放;支持 Theme Editor section 重载。 */
  function initHeroRotator(root) {
    if (!root || root.dataset.heroRotatorInit === "1") return;   // 防重复初始化
    root.dataset.heroRotatorInit = "1";

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-hero-slide]"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hero-dot]"));
    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute("data-interval"), 10);
    if (isNaN(interval)) interval = 6000;
    interval = Math.min(10000, Math.max(4000, interval));
    var autoplay = root.getAttribute("data-autoplay") === "true" && !REDUCE_MOTION;

    var idx = 0;
    var timer = null;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var active = n === idx;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
        var cta = slide.querySelector(".hero-banner__cta");
        if (cta) {
          if (active) cta.removeAttribute("tabindex");
          else cta.setAttribute("tabindex", "-1");
        }
      });
      dots.forEach(function (dot, n) {
        var active = n === idx;
        dot.classList.toggle("is-active", active);
        if (active) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
    }

    function stopTimer() {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }
    function schedule() {
      stopTimer();                                  // 任何时刻只存在一个定时器
      if (!autoplay || document.hidden) return;
      timer = window.setTimeout(function () {
        show(idx + 1);
        schedule();
      }, interval);
    }

    /* 圆点切换:立即显示,等一个完整间隔后再恢复自动播放 */
    dots.forEach(function (dot, n) {
      dot.addEventListener("click", function () {
        show(n);
        schedule();
      });
    });

    /* 悬停 / 键盘焦点进入:暂停;离开:恢复 */
    root.addEventListener("mouseenter", stopTimer);
    root.addEventListener("mouseleave", schedule);
    root.addEventListener("focusin", stopTimer);
    root.addEventListener("focusout", function (e) {
      if (!root.contains(e.relatedTarget)) schedule();
    });

    /* 触摸横滑切换(被动监听,不拦截纵向滚动) */
    var touchX = null, touchY = null;
    root.addEventListener("touchstart", function (e) {
      stopTimer();
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (touchX !== null) {
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(idx + (dx < 0 ? 1 : -1));
        }
      }
      touchX = touchY = null;
      schedule();
    }, { passive: true });

    /* 后台标签页暂停,回到前台恢复 */
    function onVisibility() {
      if (document.hidden) stopTimer();
      else schedule();
    }
    document.addEventListener("visibilitychange", onVisibility);

    /* Theme Editor section 卸载时清理定时器与文档级监听 */
    root._heroRotatorCleanup = function () {
      stopTimer();
      document.removeEventListener("visibilitychange", onVisibility);
      delete root.dataset.heroRotatorInit;
    };

    show(0);
    schedule();
  }

  function initAllHeroRotators() {
    var rotators = document.querySelectorAll("[data-hero-rotator]");
    Array.prototype.forEach.call(rotators, initHeroRotator);
  }

  /* Shopify Theme Editor:section 重载时重新初始化,卸载时清理 */
  document.addEventListener("shopify:section:load", function (e) {
    var rotator = e.target.querySelector("[data-hero-rotator]");
    if (rotator) initHeroRotator(rotator);
    var selector = e.target.querySelector("[data-country-selector]");
    if (selector) initCountrySelector(selector);
    var featured = e.target.querySelector("[data-featured-carousel]");
    if (featured) initFeaturedCarousel(featured);
    var bs = e.target.querySelector("[data-bs-carousel]");
    if (bs) initBsCarousel(bs);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var rotator = e.target.querySelector("[data-hero-rotator]");
    if (rotator && rotator._heroRotatorCleanup) rotator._heroRotatorCleanup();
    var selector = e.target.querySelector("[data-country-selector]");
    if (selector && selector._countrySelectorCleanup) selector._countrySelectorCleanup();
    var featured = e.target.querySelector("[data-featured-carousel]");
    if (featured && featured._featuredCarouselCleanup) featured._featuredCarouselCleanup();
    var bs = e.target.querySelector("[data-bs-carousel]");
    if (bs && bs._bsCleanup) bs._bsCleanup();
  });

  /* ---------- 首页商品轮播(全部商品 · 无限循环) ----------
     · 展示层克隆整组商品用于视觉循环,真实商品数据不动
     · 步进式自动播放:每 N 秒平滑左移一件,越过一组宽度后瞬时回退一组
       (两组内容逐像素相同,回绕不可察觉,不会反向大跳)
     · 悬停 / 键盘聚焦 / 拖拽 / 触摸 / 后台标签页 暂停;交互后重置计时
     · prefers-reduced-motion:不自动播放,箭头与手动滑动仍可用
     · Theme Editor 重载 section 时清理旧实例与计时器 */
  function initBsCarousel(root) {
    if (!root || root.dataset.bsInit === "1") return;   // 防重复初始化
    root.dataset.bsInit = "1";

    var track = root.querySelector("[data-bs-track]");
    if (!track) return;
    var prev = root.querySelector("[data-bs-prev]");
    var next = root.querySelector("[data-bs-next]");
    var items = Array.prototype.slice.call(track.querySelectorAll("[data-bs-item]"));
    if (items.length === 0) return;

    var autoplayOn = root.getAttribute("data-bs-autoplay") !== "false";
    var interval = parseInt(root.getAttribute("data-bs-interval"), 10);
    if (isNaN(interval)) interval = 4000;
    interval = Math.min(8000, Math.max(3000, interval));

    var setWidth = 0;        // 一组商品的总宽(含末尾间距)
    var cloned = false;
    var timer = null;
    var paused = false;
    var suppressClick = false;

    function perView() {
      var item = items[0];
      if (!item) return 1;
      var w = item.getBoundingClientRect().width;
      return w > 0 ? Math.round(track.clientWidth / w) : 1;
    }

    function cloneSet() {
      var frag = document.createDocumentFragment();
      items.forEach(function (item) {
        var c = item.cloneNode(true);
        c.setAttribute("aria-hidden", "true");
        c.setAttribute("data-bs-clone", "");
        c.removeAttribute("data-bs-item");
        // 克隆项不可聚焦,避免键盘 Tab 到重复内容
        Array.prototype.forEach.call(c.querySelectorAll("a"), function (a) {
          a.setAttribute("tabindex", "-1");
        });
        frag.appendChild(c);
      });
      track.appendChild(frag);
      cloned = true;
    }

    function measureSet() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var first = items[0];
      var last = items[items.length - 1];
      setWidth = last.offsetLeft - first.offsetLeft + last.getBoundingClientRect().width + gap;
    }

    // 商品数不超过一屏时不循环、不克隆,也不显示无效箭头
    function loopable() {
      return items.length > perView();
    }

    function ensureClones() {
      if (!loopable() || cloned) return;
      cloneSet();
      measureSet();
      // 商品很少时补足克隆,保证任何时刻轨道都填满
      var guard = 0;
      while (track.scrollWidth < track.clientWidth + setWidth + 1 && guard < 4) {
        cloneSet();
        guard++;
      }
    }

    function step() {
      var item = items[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    // 越界回绕:滚动结束后若已越过一组,瞬时减去一组宽度
    function normalize() {
      if (!cloned || setWidth <= 0) return;
      if (track.scrollLeft >= setWidth) {
        track.scrollLeft = track.scrollLeft - setWidth;
      } else if (track.scrollLeft < 0) {
        track.scrollLeft = track.scrollLeft + setWidth;
      }
    }

    function advance(dir) {
      var delta = step() * dir;
      // 向左回绕:先瞬时前移一组,再平滑左移,避免撞到 scrollLeft=0 的硬边界
      if (dir < 0 && cloned && track.scrollLeft < step()) {
        track.scrollLeft = track.scrollLeft + setWidth;
      }
      var from = track.scrollLeft;
      var target = from + delta;
      var behavior = REDUCE_MOTION ? "auto" : "smooth";
      track.scrollTo({ left: target, behavior: behavior });
      // 平滑滚动结束后归一化(动画约 400–650ms)。
      // 兜底:某些环境(后台标签页、不支持 smooth 的浏览器)平滑滚动会静默失败,
      // 届时直接落位,避免轮播卡死。
      window.setTimeout(function () {
        if (Math.abs(track.scrollLeft - from) < 1 && Math.abs(delta) > 1) {
          track.scrollLeft = target;
        }
        normalize();
      }, REDUCE_MOTION ? 20 : 700);
    }

    /* --- 自动播放 --- */
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function play() {
      stop();
      if (!autoplayOn || REDUCE_MOTION || paused || document.hidden || !loopable()) return;
      timer = window.setInterval(function () { advance(1); }, interval);
    }
    function restart() { stop(); play(); }   // 用户操作后重置计时

    /* --- 暂停规则 --- */
    root.addEventListener("mouseenter", function () { paused = true; stop(); });
    root.addEventListener("mouseleave", function () { paused = false; play(); });
    root.addEventListener("focusin", function () { paused = true; stop(); });
    root.addEventListener("focusout", function (e) {
      if (!root.contains(e.relatedTarget)) { paused = false; play(); }
    });
    track.addEventListener("touchstart", function () { paused = true; stop(); }, { passive: true });
    track.addEventListener("touchend", function () {
      paused = false;
      window.setTimeout(function () { normalize(); play(); }, 300);
    }, { passive: true });

    function onVisibility() {
      if (document.hidden) stop();
      else play();
    }
    document.addEventListener("visibilitychange", onVisibility);

    /* --- 鼠标拖动(触摸走原生滚动) --- */
    var dragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = 0;
    track.addEventListener("pointerdown", function (e) {
      paused = true; stop();
      if (e.pointerType !== "mouse") return;
      dragging = true; dragMoved = 0;
      dragStartX = e.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add("is-dragging");
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      dragMoved = Math.max(dragMoved, Math.abs(dx));
      track.scrollLeft = dragStartScroll - dx;
    });
    function endDrag() {
      if (!dragging) {
        paused = false; play();
        return;
      }
      dragging = false;
      track.classList.remove("is-dragging");
      if (dragMoved > 6) suppressClick = true;   // 拖动不触发商品链接
      normalize();
      paused = false;
      restart();
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    // 捕获阶段拦截拖动后的误点击;正常点击(未拖动)不受影响,
    // 浏览器默认行为保留 —— Cmd/Ctrl+点击仍可新标签页打开
    track.addEventListener("click", function (e) {
      if (suppressClick) {
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    track.addEventListener("dragstart", function (e) { e.preventDefault(); });

    /* --- 左右箭头:无限循环,两端都不禁用 --- */
    function updateArrows() {
      var show = loopable();
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
    }
    if (prev) prev.addEventListener("click", function () { advance(-1); restart(); });
    if (next) next.addEventListener("click", function () { advance(1); restart(); });

    function onResize() {
      if (cloned) measureSet();
      ensureClones();
      updateArrows();
    }
    window.addEventListener("resize", onResize);

    root._bsCleanup = function () {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("resize", onResize);
      delete root.dataset.bsInit;
    };

    ensureClones();
    updateArrows();
    play();
  }

  function initAllBsCarousels() {
    var carousels = document.querySelectorAll("[data-bs-carousel]");
    Array.prototype.forEach.call(carousels, initBsCarousel);
  }

  /* ---------- 滚动出现 Scroll Reveal ----------
     IntersectionObserver 统一驱动 [data-reveal]:进入视口即显示,
     只播放一次,随后取消观察;向上滚动不复位。
     启动时给 <html> 加 reveal-armed,配合 head 内联脚本的 3s 兜底。 */
  function initReveal() {
    document.documentElement.classList.add("reveal-armed");
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]"));
    if (els.length === 0) return;

    function show(el) {
      el.classList.add("is-revealed");
      el.dispatchEvent(new CustomEvent("reveal:shown"));
    }

    if (REDUCE_MOTION || !("IntersectionObserver" in window)) {
      els.forEach(show);
      return;
    }

    var ioFiredOnce = false;
    var io = new IntersectionObserver(function (entries) {
      ioFiredOnce = true;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        io.unobserve(entry.target);   // 只播一次,观察完即释放
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

    els.forEach(function (el) { io.observe(el); });

    // 降级保护:个别环境 IO 始终不回调时,退化为节流滚动检测,
    // 全部显示完即自行移除监听,不留常驻开销
    window.setTimeout(function () {
      if (ioFiredOnce) return;
      var pending = els.filter(function (el) { return !el.classList.contains("is-revealed"); });
      function inView(el) {
        var r = el.getBoundingClientRect();
        return r.top < window.innerHeight * 0.92 && r.bottom > 0;
      }
      function sweep() {
        pending = pending.filter(function (el) {
          if (inView(el)) { show(el); return false; }
          return true;
        });
        if (pending.length === 0) window.removeEventListener("scroll", onScroll);
      }
      var throttled = false;
      function onScroll() {
        if (throttled) return;
        throttled = true;
        window.setTimeout(function () { throttled = false; sweep(); }, 150);
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      sweep();
    }, 2500);
  }

  function init() {
    initAllGalleries();
    initReveal();
    initAllCountrySelectors();
    initAllHeroRotators();
    initAllBsCarousels();
    initAllFeaturedCarousels();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ---------- 试戴快捷钮门控（GM 化二期补丁） ----------
   目录页（集合/搜索/首页轮播）的 TRY ON 钮默认隐藏，向后端问一次"哪些商品能试戴"，
   只对真有资产的商品显示。无资产商品点进去只会看到空白（商品页入口本身也是隐藏的），
   与其给个没反应的按钮，不如不显示；请求失败或 JS 不可用时同样保持隐藏（失败即关闭）。
   后端地址与 sections/artryon-entry.liquid 里的一致，改动请两处同步。 */
(function () {
  var BACKEND = "https://ar.lumiereoptics.com";
  function initTryonGate() {
    if (!document.querySelector("[data-tryon-pill]")) return;
    fetch(BACKEND + "/storefront/try-on-products", { credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var ids = data && Array.isArray(data.productIds) ? data.productIds : null;
        if (!ids) return;
        var set = {};
        ids.forEach(function (id) {
          set[id] = true;
          var numeric = String(id).split("/").pop(); // 主题渲染的是数字 id，后端存的是 GID
          if (numeric) set[numeric] = true;
        });
        document.querySelectorAll("[data-tryon-pill]").forEach(function (el) {
          if (set[el.getAttribute("data-tryon-pill")]) el.hidden = false;
        });
      })
      .catch(function () { /* 后端不可达：按钮保持隐藏 */ });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initTryonGate);
  else initTryonGate();
})();
